import i18n from "@/language/i18n";
import TIMETRACKING_WIDGETS from "../widgets/TIMETRACKING_WIDGETS";
import MONTH_WIDGETS from "../widgets/MONTH_WIDGETS";
import SICK_NOTES_WIDGETS from "../widgets/SICK_NOTES_WIDGETS";

const WORKING_TIME_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    TIMETRACKING_MODULE_WINDOW_ID: 'timetracking',
    ATTENDANCE_TYPES_MODULE_WINDOW_ID: 'attendancetypes',
    OVERTIME_MODULE_WINDOW_ID: 'overtime',
    OVERTIMETRIMS_MODULE_WINDOW_ID: 'overtimetrims',
    MONTH_OF_EMPLOYEES_MODULE_WINDOW_ID: 'monthOfEmployees',
    REOPEN_MONTH_MODULE_WINDOW_ID: 'reopenMonth',
    MONTH_CONFIRMATION_MODULE_WINDOW_ID: 'monthConfirmation',
    MONTH_BALANCE_OVERVIEW_MODULE_WINDOW_ID: 'balancechange',
    MONTHLY_VERIFICATION_MODULE_ID: 'monthlyVerification',
    WORKING_HOURS_IMPORT_MODULE_ID: 'workinghoursimport',
    MONTHLY_ABSENCE_MODULE_ID: 'monthlyAbsence',
    MONTHLY_ABSENCE_CONFIGURATION_MODULE_ID: 'monthlyAbsenceConfiguration',
    SICK_NOTES_MODULE_WINDOW_ID: 'sicknotes',
    CALENDAR_MODULE_WINDOW_ID: 'calendar',
    WORKING_DAY_CONFIGURATION_MODULE_ID: 'workingDayConfiguration',
});

export { WORKING_TIME_MODULE_WINDOW_IDENTIFIER };

export default {
    WORKING_TIME_GROUP_WRAPPER: {
        type: 'group',
        id: 'workingTimeManagement',
        label: i18n.t('ModuleRegistry.groups.workingTimeManagement.name'),
        children: [],
        icon: '$wTime',
        sidebarIcon: '$wNavWorkingTimeManagment'
    },
    CHILDREN: {
        TIMETRACKING_MODULE: {
            type: 'module',
            id: 'timetracking',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.TIMETRACKING_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.timeTracking.label'),
            navigationImg: require('@/assets/navigation/items/icon_zeiterfassung.svg'),
            routerLink: '/timetracking'
        },
        ATTENDANCE_TYPES_MODULE: {
            type: 'module',
            id: 'attendanceTypes',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.ATTENDANCE_TYPES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.attendanceTypes.label'),
            navigationImg: require('@/assets/navigation/items/icon_zeiterfassung.svg'),
            routerLink: '/attendanceTypes'
        },
        OVERTIME_MODULE: {
            type: 'module',
            id: 'overtime',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.OVERTIME_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.overtime.label'),
            navigationImg: require('@/assets/navigation/items/icon_zeiterfassung.svg'),
            routerLink: '/overtime',
            widgets: TIMETRACKING_WIDGETS.OVERTIME_WIDGETS
        },
        OVERTIME_TRIM_MODULE: {
            type: 'module',
            id: 'overtimeTrimOverview',
            windowIdentifierType:
                WORKING_TIME_MODULE_WINDOW_IDENTIFIER.OVERTIMETRIMS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.overtimeTrimOverview.label'),
            navigationImg: require('@/assets/navigation/items/icon_abteilung.svg'),
            routerLink: '/overtimetrims',
            globalSearch: {
                index: 'overtimetrims'
            },
        },
        MONTH_OF_EMPLOYEES_MODULE: {
            type: 'module',
            id: 'monthOfEmployees',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTH_OF_EMPLOYEES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.overview'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthOfEmployees',
            widgets: MONTH_WIDGETS.MONTH_OF_EMPLOYEES_WIDGETS
        },
        REOPEN_MONTH_MODULE: {
            type: 'module',
            id: 'reopenMonth',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.REOPEN_MONTH_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.reopenMonth'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reopenMonth',
        },
        MONTH_CONFIRMATION_MODULE: {
            type: 'module',
            id: 'monthConfirmation',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTH_CONFIRMATION_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.confirmation'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthConfirmation',
        },
        MONTHLY_VERIFICATION_MODULE: {
            type: 'module',
            id: 'monthlyVerificationView',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTHLY_VERIFICATION_MODULE_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.verification'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthlyVerification',
        },
        MONTH_BALANCE_MODULE: {
            type: 'module',
            id: 'monthBalanceOverview',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTH_BALANCE_OVERVIEW_MODULE_WINDOW_ID,
            label: i18n.t('Month.words.balance'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/balancechange',
        },
        MONTHLY_ABSENCE_MODULE: {
            type: 'module',
            id: 'monthlyAbsence',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.MONTHLY_ABSENCE_MODULE_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.absence'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/absence',
        },
        MONTHLY_ABSENCE_CONFIGURATION_MODULE: {
            type: 'module',
            id: 'monthlyAbsenceConfiguration',
            windowIdentifierType: 'monthlyAbsenceConfiguration',
            label: i18n.t('ModuleRegistry.groups.absenceConfiguration.name'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/monthlyAbsenceConfiguration',
        },
        SICK_NOTES_MODULE: {
            type: 'module',
            id: 'sickNotes',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.SICK_NOTES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.sickNotesView.label'),
            navigationImg: require('@/assets/navigation/items/icon_krankmeldung.svg'),
            routerLink: '/sicknotes',
            globalSearch: {
                index: 'sicknotes',
                presentation: i18n.t('ModuleRegistry.groups.workingTimeManagement.sickNotesView.presentation'),
                component: 'SickNoteItem.vue',
                shortcut: '-s'
            },
            widgets: SICK_NOTES_WIDGETS.SICK_NOTES_WIDGETS
        },
        CALENDAR_MODULE: {
            type: 'module',
            id: 'monthCalendar',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.CALENDAR_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.calendar'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/calendar',
        },
        WORKING_HOURS_IMPORT_MODULE: {
            type: 'module',
            id: 'workinghoursimport',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.WORKING_HOURS_IMPORT_MODULE_ID,
            label: i18n.t('Timetracking.words.workingTimeImport'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/import',
        },
        WORKING_DAY_CONFIGURATION: {
            type: 'module',
            id: 'workingDayConfiguration',
            windowIdentifierType: WORKING_TIME_MODULE_WINDOW_IDENTIFIER.WORKING_DAY_CONFIGURATION_MODULE_ID,
            label: i18n.t('ModuleRegistry.groups.workingTimeManagement.labels.workingDayConfiguration'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/workingDayConfiguration',
        }
    }
}
